
import React from 'react';
import theme from './theme';

const ThemeContext = React.createContext(theme);

export default ThemeContext;
